import React, { ReactNode } from 'react'

import { ErrorContent, Title, Wrapper } from './styles'

type Props = {
  title?: ReactNode
  errors?: string | Array<string> | React.ReactNode | React.ReactNode[]
  style?: React.CSSProperties
}

const renderErrors = (errors: string | Array<string> | React.ReactNode | React.ReactNode[]) => {
  if (!Array.isArray(errors)) return <ErrorContent className="error">{errors}</ErrorContent>
  return Array.from(new Set(errors)).map(error => (
    <ErrorContent key={error} className="error">
      {error}
    </ErrorContent>
  ))
}

export const ErrorsList = ({ title, errors, style }: Props) => {
  return (
    <Wrapper style={style}>
      {title && <Title className="title">{title}</Title>}
      {errors && renderErrors(errors)}
    </Wrapper>
  )
}
